var PES = PES || {};
PES.PartnerstackLogic = function () {
    const PS_REF_COOKIE_NAME = "ps_ref";
    const PS_REF_DATE_COOKIE_NAME = PS_REF_COOKIE_NAME + "_d";
    const cookieExpiryDays = 90;
    const urlQueries = new URLSearchParams(window.location.search);

    function getCookies() {
        return document.cookie.split('; ').reduce((acc, cookie) => {
            const [key, value] = cookie.split('=');
            acc[key] = value;
            return acc;
        }, {});
    }

    function getRootDomain(urlHostname) {
        const parts = urlHostname.split('.').reverse();

        if (parts.length >= 2) {
            return `.${parts[1]}.${parts[0]}`;
        }

        return urlHostname;
    }

    const cookies = getCookies();
    function detectUrlQuery(pageUrl) {
        const hostname = new URL(pageUrl).hostname;

        const PS_REF_COOKIE_DOMAIN = getRootDomain(hostname);

        const urlParams = Object.fromEntries(urlQueries.entries());
        const psXidRef = urlParams["ps_xid"];

        if (psXidRef) {
            const date = new Date();
            const expiryDate = new Date();
            expiryDate.setTime(date.getTime() + (cookieExpiryDays * 24 * 60 * 60 * 1000));

            document.cookie = `${PS_REF_COOKIE_NAME}=${psXidRef}; expires=${expiryDate.toUTCString()}; domain=${PS_REF_COOKIE_DOMAIN}; path=/;`;
            document.cookie = `${PS_REF_DATE_COOKIE_NAME}=${date.toISOString()}; expires=${expiryDate.toUTCString()}; domain=${PS_REF_COOKIE_DOMAIN}; path=/;`;
        }
        if (cookies[PS_REF_COOKIE_NAME] && cookies[PS_REF_DATE_COOKIE_NAME]) {
            const psRefDate = decodeURIComponent(cookies[PS_REF_DATE_COOKIE_NAME]);
            const psRef = cookies[PS_REF_COOKIE_NAME];
            checkApiResponse(psRefDate, psRef);
        }

        function checkApiResponse(cookieDate, cookieValue) {
            (async () => {
                try {
                    const response = await fetch("/api/account");
                    if (!response.ok) {
                        return;
                    }
                    const data = await response.json();

                    if (data.userCreatedAt && data.email && new Date(data.userCreatedAt) >= new Date(cookieDate)) {
                        const psData = {
                            xid: cookieValue,
                            email: data.email,
                            action: "create_account",
                        };

                        const refResponse = await fetch("/api/next/ref", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify(psData),
                        });
                        if (refResponse.ok) {
                            document.cookie = `${PS_REF_DATE_COOKIE_NAME}=""; max-age=0; domain=${PS_REF_COOKIE_DOMAIN}; path=/;`;
                        }
                    }
                } catch (error) {
                    console.error("Error", error);
                }
            })();
        }
    }

    function init(pageUrl) {
        detectUrlQuery(pageUrl);
    };

    return {
        init: init
    };
}();